import { LocaleMessages } from 'vue-i18n'

import { enUploadLocalisationMessages } from '@/features/upload/upload.localisation'
import { enProjectListLocalisationMessages } from '@/features/projectList/projectList.localisation'
import { enMatchFieldsLocalisationMessages } from '@/features/matchFields/matchFields.localisation'
import { enAuthLocalisationMessages } from '@/features/auth/auth.localisation'
import { enJobDetailsLocalisationMessages } from '@/features/job/job.localisation'
import { enProcessingLocalisationMessages } from '@/features/processing/processing.localisation'
import { enNavBarLocalisationMessages } from '@/features/navBar/navBar.localisation'

const messages = {
  en: {
    ...enUploadLocalisationMessages,
    ...enProjectListLocalisationMessages,
    ...enMatchFieldsLocalisationMessages,
    ...enAuthLocalisationMessages,
    ...enJobDetailsLocalisationMessages,
    ...enProcessingLocalisationMessages,
    ...enNavBarLocalisationMessages
  },
  ua: {
  }
}

export default messages
